import { render, staticRenderFns } from "./SourceChannelTable.vue?vue&type=template&id=211373e0"
import script from "./SourceChannelTable.vue?vue&type=script&lang=js"
export * from "./SourceChannelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports